/* ==============================================================================
   POLYMERCRAFTS — FAQ ACCORDION LOGIC
   File: assets/faq-accordion.js
   ============================================================================== */

(function() {
  'use strict';

  function handleAccordionClick(event) {
    const btn = event.target.closest('.pc-accordion-btn');
    if (!btn) return;

    const item = btn.closest('.pc-accordion-item');
    if (!item) return;

    event.preventDefault();
    const isOpen = item.classList.contains('is-open');

    if (isOpen) {
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  }

  // Attach listener globally to document once
  if (!window.__pcFaqAccordionInitialized) {
    window.__pcFaqAccordionInitialized = true;
    document.addEventListener('click', handleAccordionClick);
  }

  // Live Search Filtering
  window.addEventListener('pc:faq:search', function(e) {
    const query = (e.detail && e.detail.query) ? e.detail.query.toLowerCase().trim() : '';

    document.querySelectorAll('.sec__pc-faq-accordion').forEach(sectionEl => {
      const items = sectionEl.querySelectorAll('.pc-accordion-item');
      let visibleCount = 0;

      items.forEach(item => {
        const questionText = item.querySelector('.pc-accordion-btn')?.innerText.toLowerCase() || '';
        const answerText = item.querySelector('.pc-accordion-panel-inner')?.innerText.toLowerCase() || '';
        const fullContent = questionText + ' ' + answerText;
        const btn = item.querySelector('.pc-accordion-btn');

        if (!query) {
          item.classList.remove('is-search-hidden', 'is-search-match');
          const defaultOpen = item.getAttribute('data-default-open') === 'true';
          item.classList.toggle('is-open', defaultOpen);
          if (btn) btn.setAttribute('aria-expanded', String(defaultOpen));
          visibleCount++;
        } else if (fullContent.includes(query)) {
          item.classList.remove('is-search-hidden');
          item.classList.add('is-search-match');
          item.classList.add('is-open');
          if (btn) btn.setAttribute('aria-expanded', 'true');
          visibleCount++;
        } else {
          item.classList.add('is-search-hidden');
          item.classList.remove('is-search-match');
        }
      });

      if (query && visibleCount === 0) {
        sectionEl.style.display = 'none';
      } else {
        sectionEl.style.display = '';
      }
    });
  });
})();
